/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ConfigureAccordion.tsx
 *
 * Project Title : RDR7000
 *
 * Description   : configure accordion component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : July 31, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : July 31, 2020
 * Description   : Added component to show and hide the accrodion in config step
 *
 *
 ******************************************************************************/

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion } from '@scuf/common';
import { AircraftDetails } from 'components/AircraftDetails';
import { toggleConfigureAccordions, selectConfigureState } from 'stores/UIStore';
import { ACCORDION_SECTIONS, ACCORDION_TITLES } from './constants';
import './ConfigureAccordion.scss';

export const ConfigureAccordion = () => {
  const { expandAircraftDetails } = useSelector(selectConfigureState);
  const dispatch = useDispatch();

  return (
    <>
      <Accordion className="configure-accordion">
        <Accordion.Content
          title={ACCORDION_TITLES[ACCORDION_SECTIONS.AircraftDetails]}
          active={expandAircraftDetails}
          onClick={() =>
            dispatch(
              toggleConfigureAccordions({
                accordion: ACCORDION_SECTIONS.AircraftDetails,
                expand: !expandAircraftDetails,
              })
            )
          }
        >
          <AircraftDetails />
        </Accordion.Content>
      </Accordion>
      
    </>
  );
};
